import React, { useState ,useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Grid } from '@material-ui/core';

import { BasicConfigurations } from './components';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(4)
  }
}));




const Settings = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Grid
        container
        spacing={4}
      >
        <Grid
          item
          md={12}
          xs={12}
          lg={12}
        >
          <BasicConfigurations />
        </Grid>
        <Grid
          item
          md={12}
          xs={12}
          lg={12}
        >
        </Grid>
      </Grid>
    </div>
  );
};

export default Settings;
